import { Controller } from "@hotwired/stimulus"

// Submits the owning form when a control inside it changes.
//
// Exists because `.claude/rules/frontend/template-first-development.md` forbids
// inline `onchange` / `onclick` handlers for filters. An inline handler also
// stops working silently the day a Content-Security-Policy without
// `unsafe-inline` lands — no error, the filter just stops responding.
//
// Usage:
//   <form data-controller="form--auto-submit">
//     <select data-action="change->form--auto-submit#submit">
export default class extends Controller {
  submit(event) {
    const form = event.target.form || this.element.closest("form") || this.element

    if (typeof form.requestSubmit === "function") {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }
}
